import { AngleLine, HorizontalLine, Line, VerticalLine } from './types';

export const isAngleLine = (line: Line): line is AngleLine => 'm' in line;

export const isHorizontalLine = (line: Line): line is HorizontalLine => 'y' in line;

export const isVerticalLine = (line: Line): line is VerticalLine => 'x' in line;
